import { api } from '@api'
import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react'
import { Quiz } from '@components/Modals/Variants/Quiz/Quiz'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'

interface Props {
    children: ReactNode
}

export const FeedbackProvider: FC<Props> = ({ children }) => {
    const { status } = useSession()
    const { pathname } = useRouter()
    const [shouldOpenQuiz, setShouldOpenQuiz] = useState(false)

    const [isOpenModal, setIsOpenModal] = useState(false)
    const shouldCheckFeedback = useMemo(() => {
        if (typeof window === 'undefined' || status !== 'authenticated' || pathname.includes('/admin')) return false

        const feedbackLastClosed = localStorage.getItem('feedbackLastClosed')
        if (!feedbackLastClosed) return true

        const lastClosed = new Date(feedbackLastClosed)
        const now = new Date()
        const hoursDiff = (now.getTime() - lastClosed.getTime()) / (1000 * 60 * 60)

        // return hoursDiff >= 12
        return hoursDiff >= 1 / 12 // 5 minutes
    }, [status, pathname])
    const { data } = api.SocialManager.isFeedbackClosed.useQuery(undefined, {
        enabled: shouldCheckFeedback,
        cacheTime: 0,
        staleTime: 0,
    })

    useEffect(() => {
        if (shouldCheckFeedback && data && !data?.isFeedbackCompleted) {
            setShouldOpenQuiz(true)
        }
    }, [data, shouldCheckFeedback])
    const handleCloseModal = () => {
        const now = new Date()
        localStorage.setItem('feedbackLastClosed', now.toISOString())
        setIsOpenModal(false)
    }

    useEffect(() => {
        if (shouldOpenQuiz) {
            setIsOpenModal(true)
        }
    }, [shouldOpenQuiz])

    return (
        <>
            {children}
            {isOpenModal && <Quiz closeHandler={handleCloseModal} />}
        </>
    )
}
